export const isNotMac = () => {
  if (process.browser) {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return userAgent.indexOf("mac") < 0;
  }
};

const env = typeof window === "undefined" ? process.env : window.env;

const serializedEnvValues = Object.keys(env).reduce((prev, next) => {
  if (next.startsWith("REACT_APP")) {
    prev.push(`${next}: '${env[next]}'`);
  }
  return prev;
}, []);

export const browserEnv = `if (!window.env) window.env = {${serializedEnvValues.join(
  ",\n"
)}}`;
